"use strict";
// @ts-ignore
try {
    self['workbox:precaching:6.0.2'] && _();
}
catch (e) { }
